import React, {Component} from 'react';
import styles from './detailBonusStates.module.scss';
import Link from 'next/link';

export default class BonusesEndedState extends Component {
  render() {
    return (
      <div className={styles.BonusesEndedState}>
        <div className={styles.BonusesEndedStateText}>
          <span>По данному бонусу закончились промокоды, мы скоро добавим новые.</span>
        </div>
        <Link href={"/bonus"}>
          <a className={styles.BonusesEndedStateLink}>Еще бонусы</a>
        </Link>
      </div>
    )
  }
}
